import { removeCjelina } from "@/utils/helpers";
import style from "./PathCourseCard.module.css";
import { useTranslation } from "react-i18next";
import { useLocalized } from "@/i18n/useLocalized";

function PathCourseCard({ course, index }) {
	const { t } = useTranslation();
	const l = useLocalized();

	return (
		<div className={style.cardHolder}>
			<div className={style.numeration}>{index + 1}.</div>
			<div className={style.card}>
				<div className={style.courseInfo}>
					<h3 title={l(course, "name")}>{l(course, "name")}</h3>
					<p>{l(course, "short_description")}</p>
					<div className={style.thumbnailHolder}>
						<img src={course.thumbnail} alt={l(course, "name")} />
					</div>
				</div>
				<div className={style.modulesHolder}>
					<div className={style.moduleOverview}>
						{course?.modules &&
							course.modules.map((module, index) => (
								<div className={style.module} key={module.slug}>
									<div className={style.circle}></div>
									<div className={style.info}>
										<h4>
											{t("paths:courseCard.module", {
												number: index + 1,
											})}
										</h4>
										<p title={removeCjelina(l(module, "name"))}>
											{removeCjelina(l(module, "name"))}
										</p>
									</div>
								</div>
							))}
					</div>
				</div>
			</div>
		</div>
	);
}

export default PathCourseCard;
